const storageKey = (sessionId) => `insight_phase5_report_ui_${sessionId}`;

export const readPhase5ReportUi = (sessionId) => {
  if (!sessionId) return {};
  try {
    return JSON.parse(sessionStorage.getItem(storageKey(sessionId)) || '{}');
  } catch {
    return {};
  }
};

export const updatePhase5ReportUi = (sessionId, update) => {
  if (!sessionId) return;
  const current = readPhase5ReportUi(sessionId);
  sessionStorage.setItem(storageKey(sessionId), JSON.stringify(update(current)));
};

export const getPhase5SectionId = (title, occurrence = 0) => {
  const base = String(title || 'section')
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '') || 'section';
  return occurrence ? `${base}-${occurrence + 1}` : base;
};

// Backward-compatible name for existing renderers; all IDs use the same implementation.
export const sectionId = getPhase5SectionId;

export const readExpandedSections = (sessionId, reportKey) =>
  readPhase5ReportUi(sessionId)?.expandedSections?.[reportKey] || [];

export const writeExpandedSections = (sessionId, reportKey, ids) => {
  updatePhase5ReportUi(sessionId, (current) => ({
    ...current,
    expandedSections: {
      ...(current.expandedSections || {}),
      [reportKey]: [...new Set(ids)],
    },
  }));
};
